import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Tab, Tabs } from "react-bootstrap";
import Historikk from "../../Common/Detalj/Historikk";
import Kommentar from "../../Common/Detalj/Kommentar";

import { getMiljogebyrerHistorikk } from "../../../actions/miljogebyrerActions";
import {
  createMiljogebyrKommentar,
  getAllMiljogebyrKommentarer,
} from "../../../actions/miljoKommentarerAction";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";

const rules = { kommentarTextarea: "required" };

export default function HistorikkOgKommentarerContainer({ miljogebyrId }) {
  const dispatch = useDispatch();
  const miljogebyrHistorikk = useSelector((state) =>
    Array.isArray(state.miljogebyrHistorikk)
      ? state.miljogebyrHistorikk.map((mh) => ({
          historikkBrukerNavn: mh.brukerNavn,
          historikkTidspunkt: mh.tidspunkt,
          felter: mh.endringer,
        }))
      : [],
  );
  const miljoKommentarer = useSelector((state) => state.miljoKommentarer);

  const [showKommentarTextarea, setShowKommentarTextarea] = useState(false);
  const [kommentarTextarea, setKommentarTextarea] = useState("");
  const [validationError, setValidationError] = useState({});

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getMiljogebyrerHistorikk(miljogebyrId));
    dispatch(getAllMiljogebyrKommentarer(miljogebyrId));
  }, []);

  function handleChange(e) {
    setKommentarTextarea(e.target.value);
    onChangeValidation(e, { kommentarTextarea, validationError }, rules);
  }

  function handleClick(e) {
    if (e.target.name === "showKommentarTextarea") {
      setShowKommentarTextarea(true);
    }
    if (e.target.name === "cancelKommentarTextarea") {
      setShowKommentarTextarea(false);
      setKommentarTextarea("");
      setValidationError({});
    }
  }

  function isValid() {
    const { isValid: valid, validationError: errors } = IsValidated(
      { kommentarTextarea, validationError: {} },
      rules,
    );
    setValidationError(errors);
    return valid;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const payload = { tekst: kommentarTextarea };
    if (isValid()) {
      dispatch(createMiljogebyrKommentar(miljogebyrId, payload)).then(() => {
        dispatch(getAllMiljogebyrKommentarer(miljogebyrId));
        setKommentarTextarea("");
      });
    }
  }

  return (
    <section className="detalj-miljogebyr-historikk-section-margin no-print">
      <Tabs
        defaultActiveKey={1}
        id="tabs-kommentarer-og-historikk-for-miljogebyr"
      >
        <Tab eventKey={1} title="Kommentarer">
          <Kommentar
            kommentarer={miljoKommentarer}
            showKommentarTextarea={showKommentarTextarea}
            kommentarTextarea={kommentarTextarea}
            validationError={validationError}
            handleChange={handleChange}
            handleClick={handleClick}
            handleSubmit={handleSubmit}
          />
        </Tab>
        <Tab eventKey={2} title="Historikk">
          <div>
            <Historikk historikkArray={miljogebyrHistorikk} />
          </div>
        </Tab>
      </Tabs>
    </section>
  );
}
